<ion-button
  fill="outline"
  size="small"
  [disabled]="isOffline()"
  (click)="showUploadDocumentModal()"
>
  <ion-icon
    src="../assets/material-symbols/upload_file_24dp.svg"
    slot="start"
  ></ion-icon>
  {{ 'general.send_document' | translate }}
</ion-button>
